export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: '18px 30px 30px',
};

export const collapsingTableWrapperStyles = {
  display: 'flex',
  flex: 1,
  width: '100%',
  overflow: 'hidden',
};

export const tableContainerStyles = {
  width: '100%',
  overflowX: 'hidden',
  transition: 'width 0.3s ease',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '5px',
};
